import styled from 'styled-components';

export const CardWrapper = styled.div`
  background-color: ${({ theme }) => theme.color.paper};
  box-shadow: ${({ theme }) => theme.shadow.low};
`;

export const CardMutedText = styled.div`
  color: ${({ theme }) => theme.color.textSecondary};
  font-size: 85%;
`;

export const ChildCardWrapper = styled.div`
  background-color: ${({ theme }) => theme.color.backgroundDistinct};
  border-bottom: 1px solid ${({ theme }) => theme.color.border};
  &:last-child {
    border-bottom: none;
  }
`;
